
import { Watch, Emit, Prop, Component, Vue, InjectReactive } from "vue-property-decorator";
import PrescriptionOne from './prescriptionOne.vue';
import { prescriptionSymptom } from "@/api/prescriptionDb";

@Component({ name: 'prescription-db-component-aiWeightTongue',
    components: {
        PrescriptionOne
    }
})
export default class AiWeightTongue extends Vue {
    @Prop() readonly currentTab: number | string
    @Prop({ default: "7" }) readonly expectedTab: number | string
    @InjectReactive() pageCurrentTab!: string|number;
    @InjectReactive() merchantId!: string|number;

    activeName = "1"
    list = [];
    total = 0;
    pageLoading = false;

    collapseChange(id) {
        if (!id) return;
        this.$nextTick(() => {
            const index = this.list.findIndex((el) => el.id == id);
            const ref = this.$refs.prescriptionOneRef[index];
            ref.prescriptionLoadPres(id, this.merchantId);
        })
    }
    @Emit("syncTotal")
    syncTotal() {
        return this.total;
    }

    @Watch("currentTab", { immediate: true })
    prescriptionSymptom(value, queryParams = {}) {
        if (String(value) !== String(this.expectedTab)) return;
        const params = {
            libCode: "10010",
            libName: "舌诊体脂",
            symptomName: "",
            pageNum: 1,
            pageSize: 20,
        }
        if (queryParams) {
            Object.assign(params, queryParams)
        }
        this.pageLoading = true;
        prescriptionSymptom(params).then((res) => {
            this.list = res.data.list || [];
            this.total = res.data.total;
            this.syncTotal();
        }).finally(() => {
            this.pageLoading = false;
        })
    }

}
